<template>
  <div class="control-section">
    <div class='h-ainfoBg'>
      <div class='h-ainfo'>
        <span class='icon hero-icon hero-icon-detailcode'></span>
        <span>{{$t("Profile.selected")}} {{ chooseCount }} {{$t("Profile.item")}}</span>
      </div>
    </div>
    <div>
      <ejs-grid ref='grid' :dataSource="data" height='100%' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column type='checkbox' headerText='testId' width='66' textAlign='Center'></e-column>
          <e-column field='plmnProfileId' :headerText='$t("Plmn.profileId")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
          <e-column field='plmnProfileName' :headerText='$t("Plmn.profileName")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
          <e-column field='mcc' :headerText='$t("Plmn.mcc")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
          <e-column field='mnc' :headerText='$t("Plmn.mnc")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
          <e-column field='amDataProfileIds' :headerText='$t("Plmn.amDataProfileIds")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
          <e-column field='snssaiProfileIds' :headerText='$t("Plmn.snssaiProfileIds")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='qryProfiles()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='addProfilePage' :element='dialog.element.eleAddProfile' :styles='dialog.styles' :messages='dialog.messages.addProfile'>
      <template v-slot:dialog-content>
        <AddProfileForm ref="addProfile" ></AddProfileForm>
      </template>
    </CustomDialog>
    <CustomDialog ref='modProfilePage' :element='dialog.element.eleModProfile' :styles='dialog.styles' :messages='dialog.messages.modProfile'>
      <template v-slot:dialog-content>
        <ModProfileForm ref="modProfile" ></ModProfileForm>
      </template>
    </CustomDialog>
    <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
    <DialogConfirm ref='dialogConfirm' :title='$t("Profile.inquiry")' :content='$t("Profile.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
    <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import Notification from "../../util/tipDialog/Notification";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddProfileForm from './dialog/AddProfileForm';
import ModProfileForm from './dialog/ModProfileForm';
import ajaxUrl from "../../data/ajaxUrl";

export default {
  name: 'PlmnTable',
  components: {
    CustomDialog,
    Notification,
    DialogConfirm,
    AddProfileForm,
    ModProfileForm,
    DialogList,
  },
  data() {
    return {
      data: {},
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      ne: {
        neid: '',
        netype: '',
        neversion: '',
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
        },
        stylesGroupList: {
          width: '30%',
          height: '80%',
          visible: false,
          model: true,
        },
        stylesSearch: {
          width: '30%',
          height: '30%',
          visible: false,
          model: true,
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddProfile: {
            target: this.$refs.addProfile,
            refName: 'eleAddProfile',
            buttonGroup: [
              { click: this.saveAddProfile, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.closeAddProfilePage, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Plmn.addProfile"),
            isClose: true,
          },
          eleModProfile: {
            target: this.$refs.modProfile,
            refName: 'eleModProfile',
            buttonGroup: [
              { click: this.saveModProfile, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.closeModProfilePage, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Plmn.modProfile"),
            isClose: true,
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("Profile.confirm"), }
              }
            ],
            title: this.$t("Profile.logger"),
            isClose: true,
          },
        },
        messages: {
          addProfile: {
            title: this.$t("Plmn.addProfile"),
          },
          modProfile: {
            title: this.$t("Plmn.modProfile"),
          },
        },
      },
      position: { X: 'Center', Y: 'Top' },
    };
  },
  provide: {
      grid: [ Reorder, Resize ],
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryProfiles();
    },
    isChooseNe() {
      if (this.ne.neid === '') {
        alert(this.$t("LteUser.pleaseSelectNE"));
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        alert(this.$t("Profile.pleaseSelectDatas"));
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        alert(this.$t("Profile.pleaseSelectOneData"));
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const plmnProfileId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        plmnProfileId.push(checkedData[i].plmnProfileId);
      }
      return plmnProfileId.length === 0 ? false : plmnProfileId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }

      return false;
    },
    openAddProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addProfile.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          this.$refs.notification.error({ title: this.$t("Profile.failed"), content: response.data.errorString });
          return;
        }
        this.$refs.addProfilePage.show();
      });
    },
    closeAddProfilePage() {
      this.$refs.addProfilePage.clear();
      this.$refs.addProfilePage.close();
    },
    saveAddProfile() {
      this.$refs.addProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddProfilePage();
        this.$refs.notification.success({ title: this.$t("Profile.success"), content: this.$t("Plmn.addProfileSuccess") });
        this.qryProfiles();
      });
    },
    openModProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
         const record = checkedDatas.map((item) => {
          return {
            ...item,
          }
        });

        this.$refs.modProfile.getJson(this.ne, record, (response) => {
          if(response.data.errorCode !== "0") {
            this.$refs.notification.error({ title: this.$t("Profile.failed"), content: response.data.errorString });
            return;
          }
          this.$refs.modProfilePage.show();
        });
      }
    },
    closeModProfilePage() {
      this.$refs.modProfilePage.clear();
      this.$refs.modProfilePage.close();
    },
    saveModProfile() {
      this.$refs.modProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModProfilePage();
        this.$refs.notification.success({ title: this.$t("Profile.success"), content: this.$t("Plmn.modProfileSuccess") });
        this.qryProfiles();
      });
    },
    delProfiles() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      const params = {
        vo: {
          profileIds: delKeys,
        },
        info: {
          msgid: "28686",
          neid: this.ne.neid,
        }
      };

      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("delPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("delPdnProfile response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("delPdnProfile response.data.resultVal null error");
          return;
        }
        // const resultVal = response.data.resultVal;
        // const operList = [];
        // for (let i = 0; i < delKeys.length; i++) {
        //   operList.push({
        //     operObj: delKeys[i],
        //     operResult: resultVal[i] ? resultVal[i].display : '',
        //   });
        // }
        // this.$refs.dialogList.addOperetionResultList(operList);
        // this.$refs.dialogList.setTotalCount(delKeys.length);
        // this.$refs.dialogListPage.show();
         this.$refs.notification.success({ title: this.$t("Profile.success"), content: this.$t("Plmn.delProfileSuccess") });
        this.qryProfiles();
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    qryProfiles(promptSuccess) {
      if (this.isChooseNe() === false) {
        return;
      }
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          flag: 0,
        },
        info: {
          msgid: "28687",
          neid: this.ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };

      this.$axios.post(ajaxUrl.qryPlmnProfile, params).then((response) => {
        if (!response) {
          console.log("qryPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryPdnProfile response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryPdnProfile response.data.resultVal error");
          return;
        }
        // 当PDN模板和用户签约模板为空时，查询设备端返回0x01000000错误码，暂时规避掉该错误
        if (response.data.resultVal.result !== 0 && response.data.resultVal.result !== 0x01000000) {
          console.log("qryPdnProfile response.data.resultVal.result error");
          this.$refs.notification.error({ title: this.$t("Profile.failed"),  content: response.data.resultVal.result.toString() });
          return;
        }
        const res = response.data.resultVal;
        if (res) {
          if (res.plmnProfileInfo) {
            const plmnProfileInfo = res.plmnProfileInfo.map(item => {
              let amDataProfileIdsStr = '';
              if (item.amDataProfileIds) {
                for(let i=0; i<item.amDataProfileIds.length; i++) {
                  if (item.amDataProfileIds[i]) {
                    amDataProfileIdsStr += item.amDataProfileIds[i];
                    if (i !== item.amDataProfileIds.length-1) {
                      amDataProfileIdsStr += ",";
                    }
                  }
                }
              }
              let snssaiProfileIdsStr = '';
              if (item.snssaiProfileIds) {
                for(let i=0; i<item.snssaiProfileIds.length; i++) {
                  if (item.snssaiProfileIds[i]) {
                    snssaiProfileIdsStr += item.snssaiProfileIds[i];
                    if (i !== item.snssaiProfileIds.length-1) {
                      snssaiProfileIdsStr += ",";
                    }
                  }
                }
              }
              return {
                ...item,
                amDataProfileIds: amDataProfileIdsStr,
                snssaiProfileIds: snssaiProfileIdsStr,
              }
            });
            this.data = plmnProfileInfo;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
        if (promptSuccess) {
          this.$refs.notification.success({ title: this.$t("Profile.success"), content: this.$t("Plmn.qryProfileSuccess") });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
